import React, { useState } from 'react'
 
 
import AgronomyRecommendationList from './AgronomyRecommendationList';
import AgronomyRecommendationForm from './AgronomyRecommendationForm';

const AgronomyRecommendation= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AgronomyRecommendationForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AgronomyRecommendationList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default AgronomyRecommendation